import { createContext, useContext, useState, ReactNode } from 'react';

interface MunicipalityContextType {
  municipalityId: string;
  setMunicipalityId: (id: string) => void;
}

const MunicipalityContext = createContext<MunicipalityContextType | undefined>(undefined);

export const MunicipalityProvider = ({ children }: { children: ReactNode }) => {
  const [municipalityId, setMunicipalityId] = useState<string>('');
  
  return (
    <MunicipalityContext.Provider value={{ municipalityId, setMunicipalityId }}>
      {children}
    </MunicipalityContext.Provider>
  );
};

export const useMunicipalityContext = () => {
  const context = useContext(MunicipalityContext);
  if (!context) {
    throw new Error('useMunicipalityContext must be used within MunicipalityProvider');
  }
  return context;
};
